<template>
	<select @change='change' v-model="selected" class='form-control my-control' :class='field_class'>
		<option v-for="option in options" :value='option.id'>
			{{ option.name }}
		</option>
	</select>
</template>

<script>
	import {DB} from './../../../constants'
	const ORGANIZATION = 'get_organization.php'

	import {EventBus} from '../../../lib/EventBus'

	export default {
		name: 'organization',
		data: function () { 
			return {
				selected: '0',
				options: []
			}
		},
		props: {
			set_id: '',
			field_class: ''
		},
		methods: {
			change () {
				EventBus.$emit(`organization`, this.selected)
			}
		},
		mounted () {
			fetch(DB + ORGANIZATION, {
				credentials: 'include'
			})
			.then(data => data.json())
			.then(data => {
				if (data) {
					this.options = data
				}
				else {
					this.options = []
				}
			})
			.catch(err => console.log(err))
		},
	}
</script>


// WEBPACK FOOTER //
// organization.vue?532d231e